import React, {
  useState,
  FunctionComponent,
} from "react";
import "./Multiselect.scss";
import { Button, Icon } from "@scuf/common";
import "@scuf/charts/honeywell/theme.css";

interface menuData {
  value: string
  text: string
  checked: boolean
}
interface IFilterProps {
  handleAllSelect?: Function| any;
  label?: string;
  dropdownData: Array<menuData>;
  dropDownDataFunction : Function;
  columnDetails: string;
  handleInputCheckboxChange?: Function | any;
  selectAllDropdown:boolean;
  multiSelectData: Array<string>
  handleRemoveOption:Function;
}
const Multiselect: FunctionComponent<IFilterProps> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // useEffect(() => {
  //   setData(props.dropdownData)
  // }, [props.dropdownData]);
  return (
    <div className="">
      <div className="multiselect--label">{props.label}</div>
      <div>
        <div
          className={`multiselect--box ${isMenuOpen ? "visible" : ""}`}
           onClick={()=>{props.dropDownDataFunction(props.columnDetails);setIsMenuOpen(!isMenuOpen)}}
          // onClick={() => 
          //   setIsMenuOpen(!isMenuOpen)}
        >
          <div className="text">
            {props.multiSelectData && props.multiSelectData.length !== 0 ? 
            props.multiSelectData.map((data)=>{
                return(
                  <Button
                  className="multiselect-select-btn"
                    icon={<Icon root="common" title={data} onClick={props.handleRemoveOption} name="close" size="small" color="#000000" />}
                    iconPosition="right"
                    type="secondary"
                    content={data}
                ></Button>
                )
            }) : 
            'Select an option'}</div>
          <Icon
            root="common"
            size="small"
            name={isMenuOpen ? "caret-up" : "caret-down"}
            className="icon"
          ></Icon>
        </div>
        {isMenuOpen && (
          <div className="multiselect">
            <div>
              <div className="multiselect__item">
                  <input className="multiselect__item--checkbox" type="checkbox" value="All" checked={props.selectAllDropdown} onChange={props.handleAllSelect}></input>
                  <span className="multiselect__item--label">All</span>
              </div>
              {props.dropdownData.map((item, idx) => (
                <div key={idx}>
                  <div className="multiselect__item">
                      <input className="multiselect__item--checkbox" type="checkbox" name={item.text} value={item.value} checked={item.checked} onChange={props.handleInputCheckboxChange}></input>
                      <span className="multiselect__item--label">{item.text}</span>           
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Multiselect;